import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "./AuthContext";

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const { activeRole } = useAuth(); // was incorrectly `role` — AuthContext exposes `activeRole`
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("byka_token");
    if (!token || !activeRole) return;

    const socketUrl =
      process.env.REACT_APP_SOCKET_URL ||
      (process.env.NODE_ENV === "production"
        ? undefined
        : "http://localhost:3001");
    const s = io(socketUrl, {
      auth: { token, activeRole },
      transports: ["websocket", "polling"],
    });

    s.on("connect", () => console.log("Socket connected:", s.id));
    s.on("disconnect", () => console.log("Socket disconnected"));

    setSocket(s);
    return () => {
      s.disconnect();
    };
  }, [activeRole]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
